<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "ReportIndex",

  data() {
    return {};
  }
};
</script>

<style lang="css" scoped></style>
